// Configuration for fields that should be rendered as dynamic dropdowns
// Maps field_name to the data source key and value field from the API response

export const DYNAMIC_DROPDOWN_FIELDS = {
  'reference_standard': {
    dataKey: 'reference_standards',
    valueField: 'value'
  },
  'bs_standard': {
    dataKey: 'reference_standards',
    valueField: 'value'
  },
  'procedure_no': {
    dataKey: 'procedure_numbers',
    valueField: 'value'
  },
  'document_reference': {
    dataKey: 'document_references',
    valueField: 'value'
  },
  'form_number': {
    dataKey: 'form_numbers',
    valueField: 'value'
  },
  'adnoc_standard': {
    dataKey: 'adnoc_group_standards',
    valueField: 'value'
  }
};
